"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:member-ordering
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Button_AttachmentsOptionalLabel: "Attachments",
                Button_ClickMenuItem: "Click selected menu item",
                Button_NextMenuItem: "Select next menu item",
                Button_OpenMenu: "Open menu",
                Button_PrevMenuItem: "Select previous menu item",
            },
        });
        /**
         * Framework base class for Button controls
         */
        var Button = /** @class */ (function (_super) {
            __extends(Button, _super);
            function Button() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Button.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.IsLabelBubble = $dyn.observable(false);
                // Note this is a temporary work around until we can add the button display for Image with text bubble
                this.isSystemDefinedAttachButton = data && data.Name === "SystemDefinedAttachButton";
                this.shouldDisplayCount = function () {
                    // Note - the server is changing textWithImageLeft to auto vs leaving it as it was set
                    //    until we fix that check for both display types
                    return _this.isSystemDefinedAttachButton && ($dyn.value(_this.ButtonDisplay) === $dyn.ui.ButtonDisplay.textWithImageLeft || $dyn.value(_this.ButtonDisplay) === $dyn.ui.autoValue);
                };
                this._buttonDisplay = $dyn.computed(function () {
                    var label = $dyn.value(_this.Label);
                    var imageName = $dyn.value(_this.ImageName);
                    var buttonDisplay = $dyn.value(_this.ButtonDisplay);
                    if (buttonDisplay === $dyn.ui.autoValue && imageName) {
                        // When auto is specified and an image is available, show it.
                        buttonDisplay = $dyn.ui.ButtonDisplay.textWithImageLeft;
                    }
                    if (!label && imageName && buttonDisplay !== $dyn.ui.ButtonDisplay.backgroundImage && buttonDisplay !== $dyn.ui.ButtonDisplay.textOnly) {
                        // If there isn't a label and we are going to show an image, hide the label element by changing to image only.
                        buttonDisplay = $dyn.ui.ButtonDisplay.imageOnly;
                    }
                    if (_this.shouldDisplayCount() || _this.TypeName === "SymbolButton") {
                        buttonDisplay = $dyn.ui.ButtonDisplay.imageOnly;
                    }
                    return buttonDisplay;
                });
                $dyn.observe(this._buttonDisplay, function () {
                    if (_this.shouldDisplayCount()) {
                        _this.IsLabelBubble(true);
                        _this.ShowLabel = true;
                        var calcAriaLabel = $dyn.label("Button_AttachmentsOptionalLabel") + " (" + _this.Label + ")";
                        _this.element.setAttribute("dyn-data-optional-label", calcAriaLabel);
                        _this.element.setAttribute("aria-label", calcAriaLabel);
                    }
                });
                if (this._buttonDisplay() === $dyn.ui.ButtonDisplay.imageOnly && !this.IsLabelBubble()) {
                    this.ShowLabel = false;
                }
                if (data && data.Command === "Popout") {
                    this._popoutEnabledObserver = $dyn.observe($dyn.options({ formStack: $dyn.shell.stack, recording: $dyn.ax.taskRecording.started }), function () {
                        _this.changePopoutEnabledState();
                    });
                }
                // TO DO: This function is no longer being used after SuperToolTips implementation and should be removed. (TFS 3750800)
                // <summary> Computes text for button tooltip.</summary>
                // <remarks> If helptext has a left parenthesis at the beginning, it is assumed that a keyboard shortcut is declared as part of the helptext.
                // Shortcut should be displayed alongside the label on the tooltip. Rest of the helptext description should be on a new line. </remarks>
                this.toolTip = $dyn.computed(function () {
                    var helpText = $dyn.value(_this.HelpText);
                    var label = $dyn.value(_this.Label);
                    // If a Title property was provided that should be the only content for the tooltip.
                    var toolTip = $dyn.value(_this.Title);
                    if (!toolTip) {
                        if (!helpText) {
                            toolTip = label;
                        }
                        else if (helpText.charAt(0) === "(") {
                            var newLineIndex = helpText.indexOf("\n");
                            if (newLineIndex !== -1) {
                                var splitHelpText = helpText.substr(newLineIndex);
                                var shortcut = helpText.substring(0, newLineIndex).trim();
                                toolTip = $dyn.format("{0} {1}{2}", label, shortcut, splitHelpText);
                            }
                            else {
                                toolTip = $dyn.format("{0} {1}", label, helpText);
                            }
                        }
                        else {
                            toolTip = $dyn.format("{0}\n{1}", label, helpText);
                        }
                    }
                    return toolTip;
                });
                $dyn.observe(this.ButtonDisplay, function (value) {
                    if (_this.element && _this.TypeName !== "MenuButton" && value === $dyn.ui.ButtonDisplay.imageOnly) {
                        _this.element.setAttribute("aria-label", $dyn.value(_this.Label));
                    }
                });
            };
            /**
             * The click event handler
             */
            Button.prototype.Clicked = function (evt) {
                var _this = this;
                if ($dyn.value(this.Enabled)) {
                    var executeClick = function () {
                        // New is handled separately from shell triggering different code path
                        if (_this.Command && _this.Command !== $dyn.shell.CalledCommandButtonFunction.New && !_this._triggerEvent(evt)) {
                            // Command was handled client side already, don't call the normal click.
                            return;
                        }
                        // Clear the messages if entire action is not done from client and further processing is allowed
                        if ($dyn.value(_this.SaveRecord) && _this.Root && _this.Root.MessageBar) {
                            // this is a temporary fix until Deliverable 1511094 and 331611 are complete
                            // The server will resend validation messages for data that wasn’t fixed so this is
                            // safe until we complete Deliverable 1511094 and 331611
                            _this.Root.MessageBar._clearWarningMessagesNotAttachedToInputControls();
                        }
                        // If the new control requires up to date information about last focused control outside action pane
                        if (_this.Root && _this.Root.updateLastClientSelectedControl && $dyn.value(_this.RequiresSelectedControl)) {
                            _this.Root.updateLastClientSelectedControl();
                        }
                        $dyn.callFunction(_this.Click, _this, evt);
                    };
                    if ($dyn.value(this.SaveRecord)) {
                        // New is a Save Record button and is handled from Shell triggering a separate code path.
                        if (this.Command && this.Command === $dyn.shell.CalledCommandButtonFunction.New && !this._triggerEvent(evt)) {
                            // Command was handled client side already, don't call the normal click.
                            return;
                        }
                        if (this.Root.HasInvalidUnboundControls()) {
                            if (this.Root && this.Root.AllowSave) {
                                this.Root.AllowSave(executeClick);
                            }
                        }
                        else {
                            executeClick();
                        }
                    }
                    else {
                        executeClick();
                    }
                }
                else if (evt) {
                    evt.preventDefault();
                }
            };
            Button.prototype.dispose = function () {
                if (this._popoutEnabledObserver) {
                    this._popoutEnabledObserver.dispose();
                    this._popoutEnabledObserver = null;
                }
                _super.prototype.dispose.call(this);
            };
            Button.prototype.getTaskGuideParams = function (options) {
                options = _super.prototype.getTaskGuideParams.call(this, options);
                options.my = $dyn.layout.qTipPosition.topCenter;
                options.at = $dyn.layout.qTipPosition.bottomCenter;
                return options;
            };
            Button.prototype.overflowMenuUpdate = function (inOverflow) {
                // currently only attachments button needs to changed based on in overflow or out
                if (this.shouldDisplayCount()) {
                    if (inOverflow) {
                        this.ShowLabel = true;
                        this.IsLabelBubble(false);
                        this._originalLabel = this.Label;
                        this.Label = this.element.getAttribute("aria-label");
                    }
                    else {
                        this.ShowLabel = true;
                        this.IsLabelBubble(true);
                        this.Label = this._originalLabel;
                    }
                }
            };
            /**
             * The keydown event handler.
             */
            Button.prototype.keyDown = function (evt) {
                if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.enter })) {
                    // Prevent the keyDown from bubbling for the Enter key so the form level enter shortcut is prevented.
                    // See documentation on this behavior in $dyn.ui.Control constructor.
                    evt.stopPropagation();
                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Enter shortcut.");
                }
                else {
                    // Pick up base control shortcuts
                    $dyn.util.handleShortcuts(this, evt);
                }
            };
            Button.prototype.couldCreateRecord = function () {
                return (this.Command && this.Command === $dyn.shell.CalledCommandButtonFunction.New);
            };
            Button.prototype._triggerEvent = function (evt) {
                var executeFurther = true;
                // Issue a client side command to see if we should continue with the click.
                var event = $.Event(this.Command);
                $(evt.target).trigger(event);
                if (event.isDefaultPrevented()) {
                    // Command was handled client side already, don't call the normal click.
                    executeFurther = false;
                }
                return executeFurther;
            };
            /**
             * Changes the enabled state of popout window during task recording.
             */
            Button.prototype.changePopoutEnabledState = function () {
                if ($dyn.length($dyn.shell.stack()) === 1) {
                    // disable irrespective of recording state
                    $dyn.setValue(this, "Enabled", false);
                }
                else {
                    $dyn.setValue(this, "Enabled", !$dyn.value($dyn.ax.taskRecording.started));
                }
            };
            return Button;
        }($dyn.ui.Control));
        controls.Button = Button;
        // Set default values on the prototype for backwards compatibility
        Button.prototype.bindUpdate = true;
        Button.prototype.Click = null;
        $dyn.ui.addPropertiesToPrototype(Button.prototype, {
            buttonStyle: {
                defaultValue: $dyn.ui.ButtonStyle.none,
                invokeHandlers: false,
                observable: true,
                options: $dyn.ui.ButtonStyle,
                serialize: true,
            },
            Command: {
                defaultValue: "",
                invokeHandlers: false,
                serialize: true,
            },
            ButtonDisplay: { defaultValue: $dyn.ui.autoValue, observable: true },
            DefaultButton: { defaultValue: false, observable: true },
            ImageName: { defaultValue: "", observable: true },
            ImageType: { defaultValue: $dyn.ui.ImageType.symbol, observable: true },
            // Note: IsBig is not being used anywhere and should be deleted (TFS 3750800)
            IsBig: { defaultValue: false, observable: true },
            SaveRecord: { defaultValue: false, observable: true },
            // ToDo: not being used anywhere...candidate for deletion. (TFS 3750800)
            Text: { defaultValue: "", observable: false },
            Toggled: { defaultValue: null, observable: true },
            HelpText: { defaultValue: "", observable: true },
            buttonDisplay: {
                backingField: "_buttonDisplay",
                defaultValue: $dyn.ui.autoValue,
                observable: true,
                options: $dyn.ui.ButtonDisplay,
                serialize: false,
            },
            Label: {
                attribute: "title",
                converter: $dyn.util.converters.notNullString,
                defaultValue: "",
                observable: true,
            },
            ShowLabel: { defaultValue: true, observable: true },
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
    /**
     * $dyn.adapter for MenuItemButton Controls, applies the Button control class with Button template.
     */
    $dyn.adapter({ id: "MenuItemButton", controlType: "Button", template: "Button" });
    /**
     * $dyn.adapter for CommandButton Controls, applies the Button control class with Button template.
     */
    $dyn.adapter({ id: "CommandButton", controlType: "Button", template: "Button" });
    /**
     * $dyn.adapter for SymbolButton Controls, applies the Button control class with SymbolButton template.
     */
    $dyn.adapter({ id: "SymbolButton", controlType: "Button", template: "SymbolButton" });
})($dyn || ($dyn = {}));

//# sourceMappingURL=Button.js.map
